"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSettings = void 0;
const core_1 = require("@zodios/core");
const user_1 = require("../core/user");
exports.updateSettings = (0, core_1.makeEndpoint)({
    method: "put",
    path: "/app/settings",
    alias: "updateSettings",
    parameters: [
        {
            name: "body",
            type: "Body",
            schema: user_1.userSettingsSchema.partial(),
        },
    ],
    response: user_1.userSettingsSchema,
});
//# sourceMappingURL=update.js.map